import React, { Component } from 'react'
import T from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Icon from '@material-ui/core/Icon'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Fab from '@material-ui/core/Fab'
import { lighten, withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import IconBack from '@material-ui/icons/ArrowBack'
import MenuIcon from '@material-ui/icons/Menu'
import { Menu } from '@material-ui/core'
import RoleHelper from 'helpers/role'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { toggleMobileMenu } from 'reducers/layout/reducer'
import FilterBlock from './FilterBlock'
import SearchBlock from './SearchBlock'

const toolbarStyles = theme => ({
  btnBack: {
    marginRight: 10,
  },
  mobileMenuButton: {
    marginRight: 2,
  },
  toolbar: {
    marginBottom: 5,
  },
  searchBlock: {
    marginRight: 10,
  },
  fab: {
    margin: 4,
    padding: 0,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 1 auto',
  },
  titleText: {
    '@media (max-width: 992px)': {
      fontSize: '1.1rem',
      lineHeight: '1.4rem',
    },
  },
  createButtonMobile: {
    '@media (max-width: 992px)': {
      marginLeft: 'auto',
    },
  },
})

class MaterialTableToolbar extends Component {
  static propTypes = {
    classes: T.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isOpenFilterDialog: false,
      anchor: null,
    }
  }

  onOpenCreationList = ({ currentTarget }) => {
    this.setState({
      anchor: currentTarget,
    })
  }

  onCloseCreationList = () => {
    this.setState({
      anchor: null,
    })
  }

  onOpenFilterDialog = () => {
    this.setState({
      isOpenFilterDialog: true,
    })
  }

  onCloseFilterDialog = () => {
    this.setState({
      isOpenFilterDialog: false,
    })
  }

  onMobileMenuClick = () => {
    const { toggleMobileMenu } = this.props
    const appContainer = document.querySelector('.main-app-container')

    if (appContainer) {
      appContainer.classList.toggle('mobile-menu-open')
    }

    toggleMobileMenu()
  }

  render() {
    const {
      psfs,
      title,
      classes,
      filtering,
      filters,
      searching,
      search,
      creating,
      roleLevel,
      goBack,
      createButton,
      allowedToManageWorkflows,
    } = this.props
    const isMobileResolution = ifWindowWidthLessThan(992)
    const shouldShowMobileMenuButton = isMobileResolution && !!goBack
    const hasMultipleOptions = Array.isArray(createButton)
    const { params, link, title: tooltipText } = !hasMultipleOptions
      ? createButton
      : {}
    const { isOpenFilterDialog, anchor } = this.state
    const createRoute = params
      ? {
          pathname: link,
          search: params,
        }
      : link

    return (
      <>
        <Paper className="table-toolbar">
          <Toolbar
            className={`${classes.toolbar}${
              goBack ? ' table-toolbar-navigation' : ''
            }`}>
            {shouldShowMobileMenuButton && (
              <IconButton
                aria-label="mobile menu button"
                size="medium"
                className={classes.mobileMenuButton}
                onClick={this.onMobileMenuClick}>
                <MenuIcon />
              </IconButton>
            )}
            {goBack && (
              <IconButton
                aria-label="back button"
                size="medium"
                className={classes.btnBack}
                onClick={goBack}>
                <IconBack />
              </IconButton>
            )}
            <div className={classes.title}>
              <Typography
                variant="h5"
                id="tableTitle"
                className={classes.titleText}>
                {title}
              </Typography>
            </div>
            <div className={classes.spacer} />
            {searching && (
              <SearchBlock className={classes.searchBlock} {...search} />
            )}
            {filtering && (
              <div className={classes.actions}>
                <Tooltip title="Filter list">
                  <IconButton
                    href={null}
                    aria-label="Filter list"
                    onClick={this.onOpenFilterDialog}>
                    <Icon>filter_list</Icon>
                  </IconButton>
                </Tooltip>
              </div>
            )}
            {creating &&
              (roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL ||
                allowedToManageWorkflows) &&
              (hasMultipleOptions ? (
                <>
                  <div
                    className={`${classes.createButtonMobile} create-button`}
                    onClick={this.onOpenCreationList}>
                    <Fab
                      href={null}
                      variant="round"
                      color="secondary"
                      size="small"
                      aria-label="Add"
                      className={classes.fab}>
                      <Icon>add</Icon>
                    </Fab>
                  </div>
                  <Menu
                    className="create-inputs-list"
                    keepMounted
                    anchorEl={anchor}
                    open={!!anchor}
                    onClose={this.onCloseCreationList}>
                    {createButton.map(option => {
                      const { params, link, title: tooltipText } = option
                      const createRoute = params
                        ? {
                            pathname: link,
                            search: params,
                          }
                        : link

                      return (
                        <Link
                          to={createRoute}
                          className="create-link"
                          key={tooltipText}>
                          {tooltipText}
                        </Link>
                      )
                    })}
                  </Menu>
                </>
              ) : (
                <Link
                  to={createRoute}
                  className={`${classes.createButtonMobile} create-button`}
                  underline="none">
                  <Tooltip title={tooltipText}>
                    <Fab
                      href={null}
                      variant="round"
                      color="secondary"
                      size="small"
                      aria-label="Add"
                      className={classes.fab}>
                      <Icon>add</Icon>
                    </Fab>
                  </Tooltip>
                </Link>
              ))}
          </Toolbar>
        </Paper>
        {filtering && (
          <FilterBlock
            psfs={psfs}
            filters={filters}
            isOpen={isOpenFilterDialog}
            onClose={this.onCloseFilterDialog}
          />
        )}
      </>
    )
  }
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    allowedToManageWorkflows: state.getIn([
      'profile',
      'profile',
      'grantedManageWorkflows',
    ]),
  }),
  {
    toggleMobileMenu,
  },
)(withStyles(toolbarStyles)(MaterialTableToolbar))
